import React from 'react';

import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { SxProps } from '@mui/material/styles';

import { AxisId } from 'ff/debrief/models';

interface Props {
    selectedAxisId: AxisId;
    onAxisSelect: (axis: AxisId) => void;
    sx?: SxProps;
}

const AxisSelectField = (props: React.PropsWithChildren<Props>) => {
    return (
        <FormControl variant="standard" sx={{ m: 1, ...props.sx }}>
            <Select
                value={props.selectedAxisId}
                onChange={e => props.onAxisSelect(e.target.value as AxisId)}
            >
                {props.children}
            </Select>
        </FormControl>
    );
};

export default AxisSelectField;
